// Generated by purs version 0.15.15
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var compare = /* #__PURE__ */ Data_Ord.compare(Data_Ord.ordNumber);
var latIsSymbol = {
    reflectSymbol: function () {
        return "lat";
    }
};
var lonIsSymbol = {
    reflectSymbol: function () {
        return "lon";
    }
};
var CoordinatesIsSymbol = {
    reflectSymbol: function () {
        return "Coordinates";
    }
};
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode);
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.numberDecode);
var Coordinates = function (x) {
    return x;
};
var eqCoordinates = {
    eq: function (x) {
        return function (y) {
            return x.lat === y.lat && x.lon === y.lon;
        };
    }
};
var ordCoordinates = {
    compare: function (x) {
        return function (y) {
            var v = compare(x.lat)(y.lat);
            if (v instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            return compare(x.lon)(y.lon);
        };
    },
    Eq0: function () {
        return eqCoordinates;
    }
};
var newtypeCoordinates = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldCoordinates = function (dictHasField) {
    return dictHasField;
};
var genericCoordinates = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCoordinates = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCoordinates)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(latIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(lonIsSymbol)(Data_Show.showNumber))(Data_Show.showNumber))))(CoordinatesIsSymbol))
};
var unscrambleDecodeCoordinates = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCoordinates)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(latIsSymbol)(Unscramble.decodeNumber1)(/* #__PURE__ */ Unscramble.decodeRecordCons(lonIsSymbol)(Unscramble.decodeNumber1)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var encodingOpts = /* #__PURE__ */ (function () {
    return {
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform,
        unwrapSingleConstructors: true,
        unwrapSingleRecordArguments: true
    };
})();
var encodeCoordinates = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericCoordinates)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(CoordinatesIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(lonIsSymbol)(encodeWithOptionsOther))(latIsSymbol)(encodeWithOptionsOther)))))(encodingOpts)
};
var decodeCoordinates = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericCoordinates)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(CoordinatesIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(lonIsSymbol)(decodeWithOptionsOther)())(latIsSymbol)(decodeWithOptionsOther)())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
export {
    Coordinates,
    encodingOpts,
    genericCoordinates,
    showCoordinates,
    eqCoordinates,
    decodeCoordinates,
    unscrambleDecodeCoordinates,
    encodeCoordinates,
    newtypeCoordinates,
    hasFieldCoordinates,
    ordCoordinates
};
